import { createApp } from 'vue';
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';
import App from './App.vue';
import store from './store';
import {i18n} from './lang';
import { filters } from '@/config/filters';
import '@/assets/css.css';

import License from "@/utils/License";

import Products from '@/components/products';
import SFProducts from '@/components/safareigtermal/products';
import VBProducts from '@/components/visitarbodegas/products';
import CRProducts from '@/components/castelldelremei/products';

import MenuItemSession from '@/components/menuItemSession';
import SFMenuItemSession from '@/components/safareigtermal/menuItemSession';
import VBMenuItemSession from '@/components/visitarbodegas/menuItemSession';
import CRMenuItemSession from '@/components/castelldelremei/menuItemSession';
import RSMenuItemSession from '@/components/rivalsite/menuItemSession';

import MenuItemBasket from '@/components/menuItemBasket';
import VBMenuItemBasket from '@/components/visitarbodegas/menuItemBasket';
import SFMenuItemBasket from '@/components/safareigtermal/menuItemBasket';
import CRMenuItemBasket from '@/components/castelldelremei/menuItemBasket';

import Voucher from '@/components/voucher';
import SFVoucher from '@/components/safareigtermal/voucher';
import CRVoucher from '@/components/castelldelremei/voucher';

import {mapGetters} from 'vuex';

// Function to configure filters in Vue 3 app
function configureFilters(app) {
  app.config.globalProperties.$filters = filters;
}

let bambuyoAppContainer = window._pg?.target;
if(bambuyoAppContainer === undefined) {
  bambuyoAppContainer = document.createElement('div');
  bambuyoAppContainer.setAttribute('id', 'bambuyo-app');
  document.querySelector('body').appendChild(bambuyoAppContainer);
}

const app = createApp(App);
app.use(store);
app.use(i18n);
app.use(VCalendar, {});
configureFilters(app);
app.mount(bambuyoAppContainer);

document.querySelectorAll('.bambuyo-products').forEach((productsContainer) => {
  const filters = productsContainer.dataset.bambuyoFilters ? JSON.parse(productsContainer.dataset.bambuyoFilters) : {};
  const orders = productsContainer.dataset.bambuyoOrders ? JSON.parse(productsContainer.dataset.bambuyoOrders) : {};

  let productsComponent = Products;
  if (License.isVisitarBodegas()) {
    productsComponent = VBProducts;
  } else if (License.isSafareigTermal()) {
    productsComponent = SFProducts;
  } else if (License.isCastellDelRemei()) {
    productsComponent = CRProducts;
  }

  const productsApp = createApp({
    components: {
      Products: productsComponent
    },
    data() {
      return {
        "filters": filters,
        "orders": orders
      };
    },
    template: `
    <div>
      <products :filters="filters" :orders="orders" />
    </div>
  `
  });
  productsApp.use(store);
  productsApp.use(i18n);
  configureFilters(productsApp);
  productsApp.mount(productsContainer);
});

document.querySelectorAll('.bambuyo-basket-quantity').forEach((element) => {
  const basketApp = createApp({
    computed: {
      ...mapGetters('basket', ['order'])
    },
    template: `
    <span>
      {{ order.orderDetails.length }}
    </span>
  `
  });
  basketApp.use(store);
  basketApp.use(i18n);
  configureFilters(basketApp);
  basketApp.mount(element);
});

document.querySelectorAll('.bambuyo-menu-item-session').forEach((element) => {
  let menuItemSessionComponent = MenuItemSession;
  if (License.isSafareigTermal()) {
    menuItemSessionComponent = SFMenuItemSession;
  } else if (License.isVisitarBodegas()) {
    menuItemSessionComponent = VBMenuItemSession;
  } else if (License.isCastellDelRemei()) {
    menuItemSessionComponent = CRMenuItemSession;
  } else if (License.isRivalSite()) {
    menuItemSessionComponent = RSMenuItemSession;
  }

  const menuItemSessionApp = createApp({
    components: {
      MenuItemSession: menuItemSessionComponent
    },
    computed: {
      ...mapGetters('session', ['customer'])
    },
    watch: {
      customer(newVal) {
        // Actualizar las clases según el estado del usuario
        if (newVal) {
          element.className = 'menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-session';
        } else {
          element.className = 'menu-item menu-item-type-custom menu-item-object-custom menu-item-session';
        }
      }
    },
    template: `<menu-item-session />`
  });
  menuItemSessionApp.use(store);
  menuItemSessionApp.use(i18n);
  configureFilters(menuItemSessionApp);

  // Añadir las clases CSS iniciales al elemento contenedor
  element.className = 'menu-item menu-item-type-custom menu-item-object-custom menu-item-session';
  element.innerHTML = '';
  menuItemSessionApp.mount(element);
});

document.querySelectorAll('.bambuyo-menu-item-basket').forEach((element) => {
  let menuItemBasketComponent = MenuItemBasket;
  if (License.isVisitarBodegas()) {
    menuItemBasketComponent = VBMenuItemBasket;
  } else if (License.isSafareigTermal()) {
    menuItemBasketComponent = SFMenuItemBasket;
  } else if (License.isCastellDelRemei()) {
    menuItemBasketComponent = CRMenuItemBasket;
  }
  const menuItemBasketApp = createApp({
    components: {
      MenuItemBasket: menuItemBasketComponent
    },
    template: `<menu-item-basket />`
  });
  menuItemBasketApp.use(store);
  menuItemBasketApp.use(i18n);
  configureFilters(menuItemBasketApp);

  // Añadir las clases CSS necesarias al elemento contenedor
  element.className = 'menu-item menu-item-type-post_type menu-item-object-page menu-item-basket';
  element.innerHTML = '';
  menuItemBasketApp.mount(element);
});

document.querySelectorAll('.bambuyo-gift-voucher').forEach((element) => {
  let voucherComponent = Voucher;
  if (License.isSafareigTermal()) {
    voucherComponent = SFVoucher;
  } else if (License.isCastellDelRemei()) {
    voucherComponent = CRVoucher;
  }
  const voucherApp = createApp({
    components: {
      Voucher: voucherComponent
    },
    template: `<Voucher />`
  });
  voucherApp.use(store);
  voucherApp.use(i18n);
  configureFilters(voucherApp);
  voucherApp.mount(element);
});
